import { Directive, HostBinding, HostListener, Input, OnChanges } from '@angular/core';
import { BrandConfigService, BrandLogoSlot } from './brand-config.service';

@Directive({ selector: 'img[brandLogo]' })
export class BrandLogoDirective implements OnChanges {
  @Input() brandLogo: BrandLogoSlot;
  @HostBinding('attr.src') src: string;
  @HostBinding('attr.alt') alt: string;
  @HostBinding('style.width') width: string;
  @HostBinding('style.height') height: string;
  @HostBinding('style.object-fit') fit = 'contain';
  @HostBinding('style.max-width') maxWidth = '100%';
  private fallbackAttempted = false;

  constructor(private branding: BrandConfigService) {}

  ngOnChanges(): void {
    const logo = this.branding.getLogo(this.brandLogo);
    this.src = logo.src;
    this.alt = logo.alt;
    this.width = logo.width === undefined ? 'auto' : logo.width + 'px';
    this.height = logo.height === undefined ? 'auto' : logo.height + 'px';
    this.fallbackAttempted = false;
  }

  @HostListener('error') onError(): void {
    if (this.fallbackAttempted) {
      return;
    }
    this.fallbackAttempted = true;
    const fallback = this.branding.getDefaultLogo(this.brandLogo).src;
    if (this.src !== fallback) {
      this.src = fallback;
    }
  }
}
